module.exports = __webpack_public_path__ + "static/media/close_ic.01c031c8.svg";